import { API_BASE_URL, API_FETCH_EXAM_RESULT_PER_UUID_PATH } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


export type ResultDetail = {
    [key: string]: boolean[]; // Keys like "hard-heard", "cat-cut", etc., and their boolean arrays
};

export type ResultItem = [
    string, // UUID
    string, // ISO timestamp
    ResultDetail, // Object with key-value pairs for result details
    number // Numeric value (e.g., 75.384)
];

export type GetFetchExamResultPerUuidReponse = {
    results: ResultItem[]; // Array of ResultItem
};


const sortResultsByDate = (data: GetFetchExamResultPerUuidReponse): GetFetchExamResultPerUuidReponse => {
    // Sort the results array in-place by the date string
    data.results.sort((a, b) => {
        const dateA = new Date(a[1]).getTime(); // Parse date string to timestamp
        const dateB = new Date(b[1]).getTime();
        return dateA - dateB; // Ascending order
    });

    return data; // Return the modified data (optional)
};



async function executeGetFetchExamResultPerUuidWithToken(accessToken: string | null, uuids: string[]): Promise<GetFetchExamResultPerUuidReponse> {
    return axios
        .post(
            API_BASE_URL + API_FETCH_EXAM_RESULT_PER_UUID_PATH,
            {
                uuids: uuids,
            },
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 200) {
                return Promise.resolve(sortResultsByDate(response.data));
            }
            throw new Error("Unexpected response status or missing data");
        })
        .catch(error => {
            if (error.response && error.response.status === 401) {
                console.log("not authenticated");
            } else if (error.response && error.response.status === 404) {
                console.log("result not found");
            } else if (error.response && error.response.status === 400) {
                console.log("Not allowed to access");
            } else {
                console.error('Error during creation:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetFetchExamResultPerUuidWithToken(accessToken: string | null, uuids: string[]): Promise<GetFetchExamResultPerUuidReponse> {

    return executeGetFetchExamResultPerUuidWithToken(accessToken, uuids)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetFetchExamResultPerUuidWithToken(accessToken, uuids);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
